"use client";
import React, { createContext, useContext, useState } from "react";
import { BASE_URL } from "../config/apiConfig";

const PasswordContext = createContext();

export const PasswordProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // ✅ Safe JSON parser
  const parseJson = async (response) => {
    try {
      return await response.json();
    } catch {
      return null;
    }
  };

  const changePassword = async (payload) => {
    setLoading(true);
    setError(null);

    try {
      const token = localStorage.getItem("token");
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const user_id = user?.id || null;

      if (!token) {
        setError("Authentication token missing");
        return {
          success: false,
          message: "Authentication token missing",
        };
      }

      const response = await fetch(`${BASE_URL}/change-password/${user_id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const data = await parseJson(response);

        setError(data?.message || "Failed to change password");

        return {
          success: false,
          message: data?.message || "Failed to change password",
        };
      }

      const data = await parseJson(response);

      if (!data) {
        setError("Invalid server response");

        return {
          success: false,
          message: "Invalid server response",
        };
      }

      return data;
    } catch (err) {
      console.error(err);

      setError(err.message || "Something went wrong");

      return {
        success: false,
        message: err.message || "Something went wrong",
      };
    } finally {
      setLoading(false);
    }
  };

  return (
    <PasswordContext.Provider
      value={{ changePassword, loading, error }}
    >
      {children}
    </PasswordContext.Provider>
  );
};

export const usePassword = () => useContext(PasswordContext);